import { COLOR_PALETTE } from 'constants/ui';

export const statusStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

export const statusDotStyles = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: COLOR_PALETTE.GREEN[6],
};
